import * as React from 'react'
import { da } from 'date-fns/locale'
import * as FocusTrap from 'focus-trap-react'
import { DayPicker } from 'react-day-picker'
import {useRef, useState} from 'react'
import {usePopper} from "react-popper";

interface DatePickerButtonProps {
  buttonLabel: string | JSX.Element
  buttonClass: string
  date: Date
  setDate: (date: Date) => void
}

export default function DatePickerButton(props: DatePickerButtonProps) {
  const { buttonLabel, buttonClass, date, setDate } = props
  const [isPopperOpen, setIsPopperOpen] = useState(false)

  const popperRef = useRef(null)
  const buttonRef = useRef(null)
  const [popperElement, setPopperElement] = useState(null)

  const popper = usePopper(popperRef.current, popperElement, {
    placement: 'bottom',
  })
  const closePopper = () => {
    setIsPopperOpen(false)
    buttonRef?.current?.focus()
  }
  const handleDaySelect = newDate => {
    setDate(newDate)
    if (newDate) {
      closePopper()
    }
  }
  return (
    <div className="">
      <div ref={popperRef}>
        <button
          ref={buttonRef}
          type="button"
          className={buttonClass}
          aria-label="Pick a date"
          onClick={() => {
            setIsPopperOpen(!isPopperOpen)
          }}
        >
          {buttonLabel}
        </button>
      </div>

      {isPopperOpen && (
        <div className="modal-window-overlay">
          <FocusTrap
            active
            focusTrapOptions={{
              initialFocus: false,
              allowOutsideClick: false,
              preventScroll: true,
              clickOutsideDeactivates: true,
              onDeactivate: closePopper,
              fallbackFocus: buttonRef.current,
            }}
          >
            <div
              tabIndex={-1}
              style={popper.styles.popper}
              className="datepicker-dialog d-block bg-white"
              {...popper.attributes.popper}
              ref={setPopperElement}
              role="dialog"
            >
              <DayPicker
                initialFocus={isPopperOpen}
                mode="single"
                locale={da}
                defaultMonth={date}
                selected={date}
                showWeekNumber={true}
                weekStartsOn={1}
                required={true}
                fixedWeeks={true}
                showOutsideDays={true}
                ISOWeek={true}
                onSelect={handleDaySelect}
              />
              <div className="d-flex justify-content-between pb-3 pr-4 pl-4 pt-1">
                <button
                  className="btn btn-outline-secondary col-5"
                  type="button"
                  onClick={() => {
                    handleDaySelect(new Date())
                  }}
                >
                  i dag
                </button>
                <button className="btn btn-outline-secondary col-5" type="button" onClick={closePopper}>
                  luk
                </button>
              </div>
            </div>
          </FocusTrap>
        </div>
      )}
    </div>
  )
}
